/* eslint-disable no-console */
'use strict';

import opt from './options';
import {isString} from './utils';

const provider = {
    debug: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error
};
const logLevels = {
    debug: 10,
    info: 20,
    warn: 30,
    error: 40
};

export default {debug, info, warn, error};

function debug() {
    if (showLevel('debug')) {
        provider.debug.apply(null, formatMessage.apply(null, arguments));
    }
}

function info() {
    if (showLevel('info')) {
        provider.info.apply(null, formatMessage.apply(null, arguments));
    }
}

function warn() {
    if (showLevel('warn')) {
        provider.warn.apply(null, formatMessage.apply(null, arguments));
    }
}

function error() {
    if (showLevel('error')) {
        provider.error.apply(null, formatMessage.apply(null, arguments));
    }
}

function showLevel(logLevel) {
    return logLevels[logLevel] >= logLevels[opt.logLevel];
}

function formatMessage(msg) {
    if (isString(msg)) {
        arguments[0] = `v-few-frg-loader: ${msg}`;
    }
    return arguments;
}
